var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubsidies({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_1027",
    "data-name": "Groupe 1027",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_131",
    "data-name": "Ellipse 131",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#d4eacd",
    opacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-hand-holding-usd",
    "data-name": "Icon awesome-hand-holding-usd",
    d: "M7.071,3.961l1.373.393a.231.231,0,0,1-.063.453h-.9a.706.706,0,0,1-.283-.06.34.34,0,0,0-.387.055l-.48.48a.329.329,0,0,0,.041.505,2.006,2.006,0,0,0,.873.316v.486a.441.441,0,0,0,.439.439h.439a.441.441,0,0,0,.439-.439V6.105A1.544,1.544,0,0,0,9.915,4.376,1.611,1.611,0,0,0,8.738,3.066L7.365,2.674a.231.231,0,0,1,.063-.453h.9a.706.706,0,0,1,.283.06A.34.34,0,0,0,9,2.226l.48-.48a.329.329,0,0,0-.041-.505A2.006,2.006,0,0,0,8.565.925V.439A.441.441,0,0,0,8.126,0H7.686a.441.441,0,0,0-.439.439V.922A1.544,1.544,0,0,0,5.894,2.652,1.611,1.611,0,0,0,7.071,3.961Zm7.585,5.046a.824.824,0,0,0-1.106,0l-2.394,2.029a1.6,1.6,0,0,1-1.038.384H7.052a.44.44,0,0,1,0-.878H9.081a.879.879,0,0,0,.044-1.757H4.977a2.935,2.935,0,0,0-1.919.722L1.853,10.541H.415A.429.429,0,0,0,0,10.98v2.635a.429.429,0,0,0,.415.439H9.663a1.607,1.607,0,0,0,1.038-.384l3.92-3.322a.912.912,0,0,0,.036-1.342Z",
    transform: "translate(7.534 7.973)",
    fill: "#43b02a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubsidies);
export default __webpack_public_path__ + "static/media/subsidies.61357c3808cbf58c458170c8133417f7.svg";
export { ForwardRef as ReactComponent };